export default "__VITE_ASSET__BSWC_Faa__"